import React, { useEffect, useState } from 'react';
import { Tag, Tooltip, Space } from 'antd';
import { BankOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { getInfoCajaActiva } from '../../services/cajaEstadoService';
import { getAllUsers } from '../../services/userService';
import { getAllCajas } from '../../services/cajaService';

const CajaStatusIndicator = () => {
    const [cajaInfo, setCajaInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cajaData, setCajaData] = useState({});
    const [userData, setUserData] = useState({});
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Detectar si es dispositivo móvil
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Cargar información de la caja activa
    const loadCajaInfo = async () => {
        try {
            const info = await getInfoCajaActiva();
            setCajaInfo(info);
        } catch (error) {
            console.error("Error al cargar información de caja activa:", error);
        } finally {
            setLoading(false);
        }
    };

    // Cargar datos complementarios (nombre de caja y cajero)
    useEffect(() => {
        const loadComplementaryData = async () => {
            try {
                const [usuarios, cajas] = await Promise.all([
                    getAllUsers(),
                    getAllCajas()
                ]);

                // Crear mapa de usuarios para acceso rápido por No
                const userMap = {};
                usuarios.forEach(user => {
                    userMap[user.No] = `${user.firstName} ${user.lastName}`;
                });
                setUserData(userMap);

                // Crear mapa de cajas para acceso rápido por No
                const cajaMap = {};
                cajas.forEach(caja => {
                    cajaMap[caja.No] = caja.nombre;
                });
                setCajaData(cajaMap);
            } catch (error) {
                console.error("Error al cargar datos complementarios:", error);
            }
        };

        loadComplementaryData();
    }, []);

    // Cargar estado inicial y configurar actualización periódica
    useEffect(() => {
        loadCajaInfo();

        // Actualizar cada 30 segundos
        const interval = setInterval(() => {
            loadCajaInfo();
        }, 30000);

        return () => clearInterval(interval);
    }, []);

    // No mostrar nada si está cargando o no hay caja abierta
    if (loading) {
        return null;
    }

    if (!cajaInfo) {
        return (
            <div style={{ color: isMobile ? '#ff4d4f' : 'inherit' }}>
                <Tooltip title="No hay caja abierta actualmente">
                    <Tag color="error" icon={<BankOutlined />} style={{
                        fontSize: isMobile ? '11px' : '14px',
                        padding: isMobile ? '2px 6px' : '0 8px',
                        margin: 0
                    }}>
                        {isMobile ? '' : 'Sin caja abierta'}
                    </Tag>
                </Tooltip>
            </div>
        );
    }

    // Obtener nombres descriptivos
    const cajaNombre = cajaData[cajaInfo.Caja] || cajaInfo.Caja;
    const cajeroNombre = userData[cajaInfo.Cajero] || cajaInfo.Cajero;

    return (
        <Space size={isMobile ? 'small' : 'middle'} style={{
            flexWrap: 'wrap',
            justifyContent: 'center',
            margin: 0
        }}>
            <Tooltip title={`Cajero: ${cajeroNombre}`}>
                <Tag color="success" icon={<BankOutlined />} style={{
                    fontSize: isMobile ? '11px' : '14px',
                    padding: isMobile ? '2px 6px' : '0 8px',
                    margin: 0
                }}>
                    {!isMobile && 'Caja: '}{cajaNombre}
                </Tag>
            </Tooltip>
            <Tooltip title={`Abierta el ${new Date(cajaInfo.FechaDeApertura).toISOString().split('T')[0]} a las ${cajaInfo.HoraDeApertura}`}>
                <Tag color="processing" icon={<ClockCircleOutlined />} style={{
                    fontSize: isMobile ? '11px' : '14px',
                    padding: isMobile ? '2px 6px' : '0 8px',
                    margin: 0
                }}>
                    {!isMobile && 'Turno: '}{cajaInfo.Turno}
                </Tag>
            </Tooltip>
        </Space>
    );
};

export default CajaStatusIndicator; 